import { useState } from 'react';
import { useSnackbar } from 'notistack';
import {
  Grid,
  Dialog,
  Button,
  Typography,
  DialogTitle,
  DialogContent
} from '@mui/material';

import { LoadingButton } from '@mui/lab';
import { makeStyles } from '@mui/styles';
import AuthUser from '@/common/utils/AuthUser';
import { callRestPostEndpoint } from '@/common/utils/api';

const useStyles: any = makeStyles(() => ({
  root: {},
  button: {
    border: 'solid',
    borderColor: '#3788d8'
  },
  runButton: {}
}));

const AutoPayDetailsModal = ({
  open,
  setModal,
  autoPay,
  customerAllData,
  getAutoPays
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const authUser = AuthUser.getAuthUser();

  const handleSubmit = async () => {
    setProcessing(true);
    setErrorMessage('');

    try {
      const retry_response = await callRestPostEndpoint(
        {
          customer_membership: autoPay?.customer_membership_id,
          authUser: authUser?.id
        },
        '/pos_retail2/retry_autopay/'
      );

      if (retry_response?.status != 'success') {
        enqueueSnackbar('Autopay failed to process', { variant: 'error' });
      } else {
        enqueueSnackbar('AutoPay Processed', { variant: 'success' });
      }
      setErrorMessage('');
      setModal(!open);
      setProcessing(false);
      getAutoPays();
    } catch (e) {
      setModal(open);
      setProcessing(false);
      setErrorMessage(e?.toString());
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setModal(false)}
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle
        style={{
          display: 'flex',
          alignItems: 'center',
          background: '#fafafa',
          padding: '10px 15px 10px 30px',
          justifyContent: 'space-between'
        }}
      >
        <h3>
          Run AutoPay for{' '}
          {customerAllData?.firstName + ' ' + customerAllData?.lastName}
        </h3>
      </DialogTitle>
      <DialogContent
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '50px 15px 50px 30px',
          justifyContent: 'space-between'
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>Process AutoPay for {autoPay.description}</Typography>
            <p style={{ color: 'red' }}>{errorMessage}</p>
          </Grid>
        </Grid>
      </DialogContent>
      <div
        style={{
          padding: '10px',
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%'
        }}
      >
        <Button
          color="primary"
          variant="contained"
          className={classes.button}
          style={{
            color: '#3788d8',
            background: '#FFFFFF',
            marginRight: '10px'
          }}
          onClick={() => {
            setModal(!open);
            setErrorMessage('');
          }}
        >
          Cancel
        </Button>
        <LoadingButton
          loading={processing}
          type="submit"
          variant="contained"
          onClick={handleSubmit}
        >
          Run Now
        </LoadingButton>
      </div>
    </Dialog>
  );
};

export default AutoPayDetailsModal;
